import angular from 'angular';

angular.module('app.core').factory('EnvelopeFilters', EnvelopeFilters);

export default class EnvelopeFilters {
  constructor() {}

  setCreatedDateFrom(createdDateFrom) {
    this.createdDateFrom = createdDateFrom;
  }

  setCreatedDateTo(createdDateTo) {
    this.createdDateTo = createdDateTo;
  }

  setUpdatedDateFrom(updatedDateFrom) {
    this.updatedDateFrom = updatedDateFrom;
  }

  setUpdatedDateTo(updatedDateTo) {
    this.updatedDateTo = updatedDateTo;
  }

  setContainerType(containerType) {
    this.containerType = containerType;
  }

  setCompanyName(companyName) {
    this.companyName = companyName;
  }

  setContainerId(containerId) {
    this.containerId = containerId;
  }

  setContainerMode(containerMode) {
    this.containerMode = containerMode;
  }

  setEnvelopeId(envelopeId) {
    this.envelopeId = envelopeId;
  }

  setEnvelopeStatus(envelopeStatus) {
    this.envelopeStatus = envelopeStatus;
  }

  setPrincipalId(principalId) {
    this.principalId = principalId;
  }

  setRefClient(refClient) {
    this.refClient = refClient;
  }

  setSender(sender) {
    this.sender = sender;
  }

  setSenderEmail(senderEmail){
    this.senderEmail=senderEmail;
  }

  setSenderName(senderName){
    this.senderName=senderName;
  }

  setReceiver(receiver) {
      this.receiver = receiver;
  }
}
